<template>
  <section id="projects" class="FilmSection s1">
    <div class="project-grid">
      <router-link
        width="16"
        height="9"
        v-for="(project, index) in projects.slice(0, 4)"
        :key="index"
        class="project-container"
        :to="`projekte/${project.path}`"
        @mouseover="hoverIn()"
        ><div
          class="project-img"
          :style="{ backgroundImage: `url(&quot;${project.image}&quot;)` }"
        >
          <div class="project-content">
            <div class="tag-wrapper">
              <div class="tag">
                <p>{{ project.tag }}</p>
              </div>
            </div>
            <div class="project-title">
              <h2>{{ project.title }}</h2>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div class="btn-center">
      <router-link class="btn-wrpr" to="projekte"
        ><button class="btn-big btn-white">no meh Projekt?</button></router-link
      >
    </div>
  </section>
</template>

<script>
export default {
  name: "FilmSection",
  computed: {
    projects() {
      return this.$store.state.projects;
    },
  },
  methods: {
    hoverIn() {
      this.projects.image = this.projects.gif;
      console.log("test");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-center {
  position: absolute;
  padding: -9rem 0 5vw 0;
  .btn-wrpr {
    padding-top: calc(50vw / 1.77 * 2);
  }
}
@media only screen and (max-width: 1024px) {
  .btn-center {
    .btn-wrpr {
      padding-top: calc(50vw / 1.77 * 8);
    }
  }
}
</style>
